import { TFunction } from "i18next";
import { Trans } from "react-i18next";
import { defaultTransComponents } from "src/config/i18n";
import { ComponentOverlayer, GenericLayer, WMSOverlayer } from "src/types";

export function isWMSOverlayer(layer: WMSOverlayer | ComponentOverlayer): layer is WMSOverlayer {
  return Object.keys(layer).includes("layers") && Object.keys(layer).includes("url");
}

export function isComponentOverlayer(layer: WMSOverlayer | ComponentOverlayer): layer is ComponentOverlayer {
  return Object.keys(layer).includes("component");
}

export function layerName(layer: GenericLayer, t: TFunction) {
  if (layer.name) {
    if (typeof layer.name === "string") {
      return <Trans i18nKey={layer.name} defaults={layer.name} components={defaultTransComponents} />;
    }
    return layer.name;
  }
  if (layer.translationKey) {
    return <Trans i18nKey={layer.translationKey} components={defaultTransComponents} />;
  }
  return "UKNOWN LAYER NAME";
}
